/*
 * The in-flight line above the athlete list while a bulk import runs. The list keeps its own
 * data and stays usable — a bulk import's outcome per row is the server's to decide, so nothing
 * is written to the table until the response lands.
 */
import React from 'react';

// Material UI
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';

// Data
import { useCompanySportTerminology } from '../../../lib/stores/company.store';
import { getImportPlayersMessages } from './import-players.messages';
import { pluralize } from '../../../lib/helpers/text.helpers';

// Components
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { Notice } from '../../_core/_ui/icons.component';

interface IImportProgressNoticeProps {
  rowCount: number;
}

export const ImportProgressNotice: React.FC<IImportProgressNoticeProps> = ({ rowCount }) => {
  const termLookup = useCompanySportTerminology();
  const messages = getImportPlayersMessages(termLookup);

  return (
    <Box mb={1}>
      <Notice icon={<CircularProgress size={16} />}>
        <IntlMsg {...messages.noticeImporting} values={{ count: rowCount, noun: pluralize(rowCount, 'row') }} />
      </Notice>
    </Box>
  );
};
